import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Clubic from '../../icons/clubic';
import { MaterialSymbol } from '../../atoms/material-symbol';
import { useImageComponent, useLinkComponent } from '../../utils/component';
import { Cta } from '../cta';
import { useTranslation } from '../../utils/translation';

const ModalOverlay = styled.div`
  &.mod-open {
    background-color: rgba(0, 0, 0, 0.75);
    box-sizing: border-box;
    bottom: 0;
    height: 100%;
    left: 0;
    overflow: auto;
    padding: 20px;
    position: fixed;
    right: 0;
    text-align: center;
    top: 0;
    width: 100%;
    z-index: 2000;

    &::before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-right: -0.05em;
    }
  }
`;

const Modalbox = styled.div`
  background: var(--theme-palette-white);
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgb(0 0 0 / 50%);
  box-sizing: border-box;
  color: var(--theme-palette-black-alt);
  display: none;
  max-width: 800px;
  padding: 0 0 0.3375rem;
  position: relative;
  text-align: left;
  vertical-align: middle;
  width: 90%;
  z-index: 2002;

  &.mod-open {
    display: inline-block;
  }
`;

const ModalHeader = styled.div`
  align-items: center;
  background: #2a3d49;
  box-sizing: border-box;
  display: flex;
  height: 66px;
  justify-content: space-between;
  padding: 0 25px;
  position: relative;
  text-align: center;
  width: 100%;
`;

const ModalHeaderCenter = styled.div`
  align-items: center;
  background: black;
  color: white;
  display: flex;
  font-size: 17px;
  font-weight: bold;
  height: 100%;
  line-height: 21px;
  margin: 0 auto;
  padding: 0 22px;
  text-transform: uppercase;
  width: 225px;
  position: absolute;
  left: 0;
  right: 0;
`;

const ModalHeaderClose = styled.div`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAA3hJREFUaAXlm8+K00Acx7MiCIJH/yw+gA9g25O49SL4AO3Bp1jw5NvktC+wF88qevK4BU97EmzxUBCEolK/n5gp3W6TTJPfpNPNF37MNsl85/vN/DaTmU6PknC4K+pniqeKJ3k8UnkvDxXJzzy+q/yaxxeVHxW/FNHjgRSeKt4rFoplzaAuHHDBGR2eS9G54reirsmienDCTRt7xwsp+KAoEmt9nLaGitZxrBbPFNaGfPloGw2t4JVamSt8xYW6Dg1oCYo3Yv+rCGViV160oMkcd8SYKnYV1Nb1aEOjCe6L5ZOiLfF120EjWhuBu3YIZt1NQmujnk5F4MgOpURzLfAwOBSTmzp3fpDxuI/pabxpqOoz2r2HLAb0GMbZKlNV5/Hg9XJypguryA7lPF5KMdTZQzHjqxNPhWhzIuAruOl1eNqKEx1tSh5rfbxdw7mOxCq4qS68ZTjKS1YVvilu559vWvFHhh4rZrdyZ69Vmpgdj8fJbDZLJpNJ0uv1cnr/gjrUhQMuI+ANjyuwftQ0bbL6Erp0mM/ny8Fg4M3LtdRxgMtKl3jwmIHVxYXChFy94/Rmpa/pTbNUhstKV+4Rr8lLQ9KlUvJKLyG8yvQ2s9SBy1Jb7jV5a0yapfF6apaZLjLLcWtd4sNrmJUMHyM+1xibTjH82Zh01TNlhsrOhdKTe00uAzZQmN6+KW+sDa/JD2PSVQ873m29yf+1Q9VDzfEYlHi1G5LKBBWZbtEsHbFwb1oYDwr1ZiF/2bnCSg1OBE/pfr9/bWx26UxJL3ONPISOLKUvQza0LZUxSKyjpdTGa/vDEr25rddbMM0Q3O6Lx3rqFvU+x6UrRKQY7tyrZecmD9FODy8uLizTmilwNj0kraNcAJhOp5aGVwsAGD5VmJBrWWbJSgWT9zrzWepQF47RaGSiKfeGx6Szi3gzmX/HHbihwBser4B9UJYpFBNX4R6vTn3VQnez0SymnrHQMsRYGTr1dSk34ljRqS/EMd2pLQ8YBp3a1PLfcqCpo8gtHkZFHKkTX6fs3MY0blKnth66rKCnU0VRGu37ONrQaA4eZDFtWAu2fXj9zjFkxTBOo8F7t926gTp/83Kyzzcy2kZD6xiqxTYnHLRFm3vHiRSwNSjkz3hoIzo8lCKWUlg/YtGs7tObunDAZfpDLbfEI15zsEIY3U/x/gHHc/G1zltnAgAAAABJRU5ErkJggg==');
  cursor: pointer;
  display: block;
  height: 30px;
  position: absolute;
  text-indent: -9999px;
  top: 17.5px;
  right: 17.5px;
  width: 30px;
`;

const ModalContent = styled.div`
  background: white;
  padding: 40px 20px 30px;
  position: relative;
  text-align: center;
  width: 100%;
`;

const ModalContentSponsored = styled.span`
  position: absolute;
  font-size: 11px;
  padding: 6px 8px;
  right: 0;
  top: 0;
`;

const ModalContentLogo = styled.div`
  display: flex;
  justify-content: center;
`;

const ModalContentTitle = styled.p`
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  text-rendering: optimizeLegibility;
  line-height: 1.2;
  letter-spacing: 0.02rem;
  margin: 13px 0 32px 0;
  font-size: 1.375rem;
  text-align: center;
`;

const ModalContentReassurance = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 7px;
`;

const ModalContentReassuranceItem = styled.div`
  padding: 0 7px;
`;

const ModalContentReassuranceItemSymbol = styled(MaterialSymbol)`
  color: var(--theme-color-primary);
  font-size: 48px !important;
  margin: 0 0 11px 0;
  width: auto;
`;

const ModalContentReassuranceItemTitle = styled.strong`
  display: block;
  line-height: 1.2;
  margin: 0 0 15px;
`;

const ModalContentReassuranceItemText = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 21px;
  margin: 0;
`;

const ModalContentDownload = styled.div`
  > * {
    display: inline-block;
    font-size: 20px;
    margin: 28px 0 0 0;
    text-transform: uppercase;
  }
`;

const ModalFooter = styled.div`
  cursor: pointer;
  text-align: center;
  background: var(--theme-palette-dark-white);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top: 1px solid #a6a6a6;
  color: initial !important;
  display: block;
  font-size: 14px;
  margin-bottom: -10px;
  padding: 13px 0;
  width: 100%;
`;

const Install = styled.div`
  text-align: center;
`;

const InstallTop = styled.div`
  padding: 20px;
`;

const InstallTitle = styled.p`
  font-size: 30px;
  font-weight: bold;
  line-height: 1.4;
  margin: 20px 0 5px;
`;

const InstallDescription = styled.p`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.4;
  margin: 0 0 10px;
`;

const InstallSteps = styled.div`
  display: flex;
  justify-content: center;
  list-style-position: inside;
  margin-bottom: 48px;
  text-align: center;
`;

const InstallStep = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: block;
  padding: 88px 6px 0;
  position: relative;
  text-align: center;
  width: 30%;

  &::before {
    background: #e0e0e0;
    bottom: 0;
    content: '';
    height: 2px;
    left: 0;
    position: absolute;
    right: 0;
    top: 34px;
    width: auto;
  }

  &:first-of-type::before {
    top: 34px;
    right: 0;
    left: 50%;
    width: auto;
    height: 2px;
  }

  &:last-of-type::before {
    right: 50%;
    left: 0;
    display: block;
  }
`;

const InstallStepCounter = styled.div`
  margin: 0 0 3px;
`;

const InstallStepCircle = styled.p`
  background: var(--theme-palette-white);
  border: 2px solid var(--theme-color-primary);
  border-radius: 50%;
  box-shadow: 0 0 0 20px var(--theme-palette-white);
  color: var(--theme-color-primary);
  font-weight: bold;
  font-size: 24px;
  height: 68px;
  left: 50%;
  line-height: 66px;
  margin: 0;
  position: absolute;
  text-align: center;
  top: 0;
  transform: translateX(-50%);
  width: 68px;

  &.mod-arrow::before {
    border-right: 2px solid #e0e0e0;
    border-top: 2px solid #e0e0e0;
    content: '';
    height: 12px;
    left: -34px;
    position: absolute;
    top: 27px;
    transform: rotate(45deg);
    width: 12px;
  }
`;

const InstallStepInformation = styled.p`
  font-size: 16px;
  line-height: 1.4;
  margin: 0;
`;

export type ModalProps = {
  columns: [
    {
      iconSlug: string;
      title: string;
      description: string;
    },
  ];
  campaignName: string;
  software: string;
  sticker: string;
  lead: string;
  imageId: string;
  trigger: number;
  callback: (id: string, os: string) => void;
  fileId: string;
  downloadUrl?: string;
  os: string;
  userAgentOs: string;
  clickRef: () => void;
  [key: string]: any;
  trackEvent: (obj: any) => any;
};

export type TrackEventCustomVariable = {
  id: number;
  name: string;
  value: string;
};

export type TrackViewDimension = {
  id: string;
  value: string;
};

export const Modal = ({ ...props }: ModalProps) => {
  const {
    columns,
    clickRef,
    imageId,
    lead,
    software,
    sticker,
    trigger,
    callback,
    fileId,
    os,
    campaignName,
    userAgentOs,
    url,
    trackEvent,
  } = props;

  const downloadUrl = useMemo(() => {
    if (os === 'Web') {
      return props[`${userAgentOs?.toLowerCase()}Url`];
    }

    return props[`${os?.toLowerCase()}Url`];
  }, [userAgentOs, os, props]);

  const [isOpen, setIsOpen] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState<boolean>(false);

  const t = useTranslation();
  const LinkComponent = useLinkComponent();

  const ImageComponent = useImageComponent();
  const imageProps = useMemo(
    () => ({
      imageId,
      alt: '',
      mobileWidth: 153,
      mobileHeight: 56,
      desktopWidth: 153,
      desktopHeight: 56,
      lazy: false,
    }),
    [imageId],
  );

  const ctaProps = useMemo(
    () => ({
      href: downloadUrl,
      openInNewWindow: true,
      rel: ['nofollow'],
      referer: software,
      event: {
        type: 'download_modal',
        softwareName: software,
        softwareOs: os,
        softwareCampaignName: campaignName ?? '',
      },
    }),
    [downloadUrl, os, campaignName, software],
  );

  const ctaDownloadProps = useMemo(
    () => ({
      openInNewWindow: true,
      rel: ['nofollow'],
      event: {
        type: 'download',
        softwareName: software,
        softwareOs: os,
      },
    }),
    [software, os],
  );

  const close = useCallback(() => setIsOpen(false), [setIsOpen]);

  useEffect(() => {
    setIsOpen(trigger > 0);
  }, [trigger]);

  const startDownloadModal = useCallback(() => {
    const userToken = localStorage.getItem('actionToken');
    const trackViewDimension: TrackViewDimension[] = [{ id: 'dimension10', value: campaignName }];
    const trackEventCustomVariable: TrackEventCustomVariable[] = [{ id: 2, name: 'campaignDL', value: campaignName }];
    clickRef();
    trackEvent({
      variables: {
        userToken,
        eventCategory: 'SoftwarePage',
        eventName: 'download_modal',
        actionName: 'download_modal',
        eventValue: software,
        customDimensions: trackViewDimension,
        customVariables: trackEventCustomVariable,
        url,
      },
    });
  }, [campaignName, software, clickRef, trackEvent, url]);

  const startDownload = useCallback(() => {
    setIsDownloaded(true);
    startDownloadModal();
  }, [setIsDownloaded, startDownloadModal]);

  return (
    <ModalOverlay className={isOpen ? 'mod-open' : ''} onClick={close}>
      <Modalbox className={isOpen ? 'mod-open' : ''} onClick={(e: any) => e.stopPropagation()}>
        <ModalHeader>
          <Clubic width={71} height={38} />
          <ModalHeaderCenter>{sticker}</ModalHeaderCenter>
          <ModalHeaderClose onClick={close} />
        </ModalHeader>
        <ModalContent>
          {isDownloaded ? (
            <Install>
              <InstallTop>
                <ModalContentLogo>
                  <ImageComponent {...imageProps} />
                </ModalContentLogo>
                <InstallTitle>{t('design.download.modalSuccess.title')}</InstallTitle>
                <InstallDescription>
                  {t('design.download.modalSuccess.description')}&nbsp;
                  <LinkComponent {...ctaProps} onClick={startDownloadModal} className="mod-primary">
                    {t('design.download.clickHere')}
                  </LinkComponent>
                </InstallDescription>
              </InstallTop>
              <InstallSteps>
                <InstallStep>
                  <InstallStepCounter>
                    <InstallStepCircle>1</InstallStepCircle>
                  </InstallStepCounter>
                  <InstallStepInformation>{t('design.download.modalSuccess.stepOne')}</InstallStepInformation>
                </InstallStep>
                <InstallStep>
                  <InstallStepCounter>
                    <InstallStepCircle className="mod-arrow">2</InstallStepCircle>
                  </InstallStepCounter>
                  <InstallStepInformation>{t('design.download.modalSuccess.stepTwo')}</InstallStepInformation>
                </InstallStep>
                <InstallStep>
                  <InstallStepCounter>
                    <InstallStepCircle className="mod-arrow">3</InstallStepCircle>
                  </InstallStepCounter>
                  <InstallStepInformation>Profitez de {campaignName}</InstallStepInformation>
                </InstallStep>
              </InstallSteps>
            </Install>
          ) : (
            <>
              {downloadUrl && (
                <LinkComponent {...ctaProps} onClick={startDownload}>
                  <ModalContentSponsored>{t('design.download.partner')}</ModalContentSponsored>
                </LinkComponent>
              )}
              <ModalContentLogo>
                <ImageComponent {...imageProps} />
              </ModalContentLogo>
              <ModalContentTitle>{lead}</ModalContentTitle>
              <ModalContentReassurance>
                {columns.map((column, index) => (
                  <ModalContentReassuranceItem key={index}>
                    <ModalContentReassuranceItemSymbol symbol={column.iconSlug} />
                    <ModalContentReassuranceItemTitle>{column.title}</ModalContentReassuranceItemTitle>
                    <ModalContentReassuranceItemText>{column.description}</ModalContentReassuranceItemText>
                  </ModalContentReassuranceItem>
                ))}
              </ModalContentReassurance>
              {downloadUrl ? (
                <ModalContentDownload>
                  <Cta className="mod-green" {...ctaProps} onClick={startDownload}>
                    {t('design.download.free')}
                  </Cta>
                </ModalContentDownload>
              ) : null}
            </>
          )}
        </ModalContent>
        <ModalFooter>
          <LinkComponent
            {...ctaDownloadProps}
            onClick={() => {
              setIsOpen(false);
              callback(fileId, os);
            }}
          >
            {t('design.download.continue')} {software}
          </LinkComponent>
        </ModalFooter>
      </Modalbox>
    </ModalOverlay>
  );
};
